'use strict';
var stickyHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

stickyHeader = require('../sticky_header');

Groupon.LS.Header.PNPrimaryNav = (function(superClass) {
  extend(PNPrimaryNav, superClass);

  function PNPrimaryNav($primaryNav) {
    this.$primaryNav = $primaryNav;
    this.setRailSlide = bind(this.setRailSlide, this);
    this.moveActiveMarker = bind(this.moveActiveMarker, this);
    this.openSubnav = bind(this.openSubnav, this);
    this.handleOpenSubnav = bind(this.handleOpenSubnav, this);
    this.initialize();
    this.bind();
  }

  PNPrimaryNav.prototype.initialize = function() {
    this.$primaryTabs = this.$primaryNav.find(".primary-nav-tab");
    this.$subnavs = $('.subnav-flyout');
    this.localHeightCalculated = false;
    this.timeoutID = 0;
    this.$railSlide = $('#ls-rail-slide');
    setTimeout(this.moveActiveMarker, 100);
    return this.setAriaAttributes();
  };

  PNPrimaryNav.prototype.bind = function() {
    var $primaryTabsLinks, cancelActiveMarkerTimer, cancelSubnavTimer, closeSubnav, moveMarkerOnResize, startsActiveMarkerTimer, startsSubnavTimer;
    if (Groupon.PageFlags.isLegacyResponsive) {
      moveMarkerOnResize = (function(_this) {
        return function() {
          return _this.moveActiveMarker();
        };
      })(this);
      $(window).on('resize', _.debounce(moveMarkerOnResize, 50));
    }
    closeSubnav = (function(_this) {
      return function() {
        if (!$('.primary-nav:hover').length) {
          _this.closeSubnav();
          window.clearTimeout(_this.timeoutID);
        }
        return stickyHeader.resume();
      };
    })(this);
    startsSubnavTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout(closeSubnav, 50);
      };
    })(this);
    cancelSubnavTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    startsActiveMarkerTimer = (function(_this) {
      return function() {
        return _this.activeMarkerTimeout = setTimeout(_this.moveActiveMarker, 50);
      };
    })(this);
    cancelActiveMarkerTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.activeMarkerTimeout);
      };
    })(this);
    this.$primaryNav.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    this.$primaryTabs.on({
      mouseenter: (function(_this) {
        return function(e) {
          cancelActiveMarkerTimer();
          return _this.moveActiveMarker($(e.currentTarget));
        };
      })(this)
    });
    this.$subnavs.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    $primaryTabsLinks = this.$primaryTabs.find('a').map(function() {
      if ($('#subnav-' + this.parentNode.id).length) {
        return this;
      }
    });
    if (Groupon.LS.hasTouch) {
      $primaryTabsLinks.addClass('lstouch');
      $primaryTabsLinks.on('lstouch', (function(_this) {
        return function(e) {
          var parent;
          parent = e.currentTarget.parentNode;
          if ($('#subnav-' + parent.id).is(':visible')) {
            _this.closeVisibleSubnav();
          } else {
            $('html').trigger('tap');
            $(parent).trigger('touch', e);
          }
          return false;
        };
      })(this));
      $('html').on('tap', (function(_this) {
        return function(e) {
          if ($('.subnav').height() && $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length === 0) {
            return _this.closeVisibleSubnav();
          }
        };
      })(this));
    }
    this.$primaryTabs.on('mouseenter touch', (function(_this) {
      return function(e) {
        e.stopPropagation();
        return _this.handleOpenSubnav(e);
      };
    })(this));
    return this.ariaBindMenuTrigger($primaryTabsLinks);
  };

  PNPrimaryNav.prototype.closeSubnav = function() {
    var ref;
    if ((ref = this.$currentFlyoutLinks) != null) {
      ref.attr('tabindex', '-1');
    }
    this.$subnavs.hide();
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.closeVisibleSubnav = function($activeTab) {
    this.closeSubnav();
    if ($activeTab != null) {
      $activeTab.focus();
    }
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.handleOpenSubnav = function(e) {
    var $flyout, $tab, eventType, flyoutDelay, openSubnav;
    window.clearTimeout(this.timeoutID);
    flyoutDelay = $('.subnav-flyout').is(':visible') ? 0 : 300;
    $tab = $(e.currentTarget);
    if ($tab.is('a')) {
      $tab = $tab.parent();
    }
    eventType = e.type;
    $flyout = $("#subnav-" + ($tab.attr('id')));
    if (!$flyout.length || $flyout.not(".ls-s-flyout-enabled").length) {
      this.closeSubnav();
    }
    if ($flyout.length) {
      stickyHeader.pause();
      $('.typeahead-response').hide();
      openSubnav = (function(_this) {
        return function() {
          return _this.openSubnav($tab, $flyout, eventType);
        };
      })(this);
      if (flyoutDelay) {
        return this.timeoutID = setTimeout(openSubnav, flyoutDelay);
      } else {
        return openSubnav();
      }
    }
  };

  PNPrimaryNav.prototype.openSubnav = function($tab, $flyout, eventType) {
    var $activeTab, $currentFlyoutLinks;
    $activeTab = $tab.find('a').eq(0);
    $activeTab.addClass('active');
    $flyout.trigger('tab:active');
    $flyout.show();
    $flyout.find('.ls-lazy').lazyload({
      skip_invisible: false
    });
    if (eventType === 'keydown') {
      $currentFlyoutLinks = $flyout.find('a');
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0');
      return this.initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks);
    }
  };

  PNPrimaryNav.prototype.moveActiveMarker = function($link) {
    var left, position, width;
    if ($link == null) {
      $link = this.$primaryTabs.filter('.default');
    }
    if (!$link.length) {
      $link = this.$primaryNav.find('.ls-current-app');
    }
    if ($link.is('li')) {
      $link = $link.find("a");
    }
    if ($link.length) {
      left = $link.position().left;
      position = left - 10;
      width = $link.width() + 20;
      return this.$railSlide.show().css('left', position).css('width', width);
    } else {
      return this.$railSlide.hide();
    }
  };

  PNPrimaryNav.prototype.setRailSlide = function($link) {
    var center, left;
    if ($link.length) {
      left = $link.position().left;
      center = left + ($link.width() / 2);
      return this.$railSlide.show().css('left', center);
    }
  };

  PNPrimaryNav.prototype.ariaBindMenuTrigger = function($trigger) {
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          return _this.handleOpenSubnav(e);
        }
      };
    })(this));
  };

  PNPrimaryNav.prototype.ariaCloseMenu = function($trigger) {
    return this.closeVisibleSubnav($trigger);
  };

  PNPrimaryNav.prototype.setAriaAttributes = function() {
    var $subnav, $tab, i, len, ref, results, tab, tabID;
    ref = this.$primaryTabs;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      tab = ref[i];
      $tab = $(tab);
      tabID = tab.id;
      $subnav = $("#subnav-" + tabID);
      results.push(this.initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a')));
    }
    return results;
  };

  return PNPrimaryNav;

})(Groupon.AriaMenuNavigation);

